import isEAN from './isEAN';

export function getEanFromURI(uri: string) {
  const segments = uri.split('/');
  const result = segments.find((s) => isEAN(s));

  return result || null;
}
